export function stripHTML(text) {
  // Remove HTML tags
  text = text.replace(/<[^>]*>/g, "");

  // Remove CSS styles
  text = text.replace(/style\s*=\s*(["'])(?:(?!\1)[^\\]|\\.)*?\1/gi, "");

  return text;
}
